// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'sitewide-react' or its corresp... Remove this comment to see the full error message
import React from 'sitewide-react';
import routes from 'sitewide-js/core_pre_webpack/routes';

import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';

enum AccessMethod {
  Download = 'downloaded',
  Viewed = 'viewed',
}

interface Props extends OnsitePingProps {
  workTitle: string;
  numBooks: number;
  researchInterest: string;
  accessMethod: AccessMethod;
  researchInterestId: number;
}

export default class BulkDownloadBooksPing extends OnsitePing<Props> {
  getTitle() {
    return 'Bulk Download Books';
  }

  getBody() {
    if (this.props.accessMethod == null) {
      return (
        <div className="text">
          Download <strong>{this.props.numBooks} books</strong> in{' '}
          {this.props.researchInterest}.
        </div>
      );
    } else {
      return (
        <div className="text">
          You {this.props.accessMethod} the paper, "{this.props.workTitle}".
          Download <strong>{this.props.numBooks} books</strong> in{' '}
          {this.props.researchInterest}.
        </div>
      );
    }
  }

  getUpgradeURL() {
    const upgradeRedirectParams = {
      q: '*',
      ri_ids: this.props.researchInterestId,
      auto_bd_books: true,
    };

    const upgradeRedirectUrl = routes.search_url(upgradeRedirectParams);

    return routes.upgrade_url({
      feature: 'bd_books',
      trigger: 'bulk_download_books_ping',
      upgrade_redirect: encodeURIComponent(upgradeRedirectUrl),
      ri: this.props.researchInterestId,
    });
  }

  getButtonText() {
    return 'Upgrade to Bulk Download Books';
  }

  getIconClassName() {
    return 'fa fa-book fa-lg icon';
  }
}
